import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const CatalogActionsToggle = ({ catalog, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(catalog.active ? 'actions.deactivate' : 'actions.activate')}
    color={catalog.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={catalog.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(catalog.id);
    }}
  />
);

export default translate()(CatalogActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/actions/CatalogsActionsToggle.js